export const getProductionUnitFacilityId = (unit: IProductionUnitListItem): string | null => {
	const targetId = unit.targetFacilityId?.trim()
	if (targetId) return targetId

	if (unit.id !== null && unit.id !== undefined && unit.id !== '') {
		return String(unit.id)
	}

	return null
}

export const ProductionUnitFromFacility = (facility: IFacility): IProductionUnitListItem => {
	const facilityId = facility.identifier?.trim() || String(facility.id)
	const capabilities = facility.capabilities ?? []

	const type = facility.type ?? (facility.is_virtual ? 'virtual' : '')

	return {
		id: facility.id,
		name: facility.name,
		targetFacilityId: facilityId,
		functions: capabilities,
		type,
	}
}

export const mapFacilitiesToProductionUnits = (facilities?: IFacility[] | null): IProductionUnitListItem[] => {
	if (!facilities?.length) return []

	return facilities.map(ProductionUnitFromFacility)
}
